function ProductSlider(container, params) {
  try {
    if (!container) {
      throw 'Container is required';
    }

    this.container = container;

    if (params) {
      this.setParams(params);
    }

    this.init();
  } catch (error) {
    console.error(error);
  }
}

ProductSlider.prototype = {
  container:undefined,
  breakpoint: undefined,
  pagerPrev: undefined,
  windowWidth: undefined,
  sliderContainer: undefined,
  sliderInner:undefined,
  sliderWidth:0,
  containerWidth:0,
  init: function() {
    this.windowWidth = window.innerWidth;
    this.setElements();
    this.setContainerWidth();
    this.setSliderContentWidth();
    this.addDOMEvents();
    this.slide(0);
  },
  setElements: function() {
    this.sliderContainer = this.container.find('[data-purpose="slider-container"]');
    this.sliderInner = this.container.find('[data-purpose="slider-inner"]').first();
    this.pagerNext = this.container.find('[data-purpose="next-pager"]');
    this.pagerPrev = this.container.find('[data-purpose="prev-pager"]');

  },
  addDOMEvents: function() {
    var _self = this;

    if (this.pagerNext.length > 0) {
      this.pagerNext.click(function(){
          _self.slide(-1);
      });
    }

    if (this.pagerPrev.length > 0) {
        this.pagerPrev.click(function(){
            _self.slide(1);
        });
    }

    $(document).on('unnepekaruhaza.window_width_changed', function(e, newWidth){
      _self.windowWidth = newWidth;
      _self.setContainerWidth();
      _self.setSliderContentWidth();
      _self.slide(0);
    });
  },
  setParams: function(params) {
    if (params.breakpoint) this.setBreakpoint(params.breakpoint);
  },
  setBreakpoint: function(breakpoint) {
    this.breakpoint = breakpoint;
  },
  getBreakpoint: function() {
    return this.breakpoint;
  },
  setSliderContentWidth: function() {
    var width = 0;
    if (this.sliderInner) {
      this.sliderInner.children().each(function(){
          width += $(this).outerWidth(true);
      });

      this.sliderInner.width(width);
    }

    this.sliderWidth = width;
  },
  getSliderContentWidth: function() {
    return this.sliderWidth;
  },
  setContainerWidth: function() {
    this.containerWidth = this.sliderContainer.outerWidth();
  },
  getContainerWidth: function() {
    if (!this.containerWidth) {
      this.setContainerWidth();
    }
    return this.containerWidth;
  },
  slide: function(direction) {
    if (!direction) {
      direction = 0;
    }

    var innerWidth = this.getContainerWidth();
    var boxWidth = 230;
    var stepSize = Math.floor((innerWidth + 50) / boxWidth) * boxWidth;
    var currentSlide = parseInt(this.sliderInner.data('current-slide'));
    var contentWidth = this.getSliderContentWidth();

    if (isNaN(currentSlide)) {
        currentSlide = 0;
    }

    currentSlide += (stepSize * direction);

    if (currentSlide >= 0) {
      currentSlide = 0;
      if (this.pagerPrev.hasClass('active')) {
        this.pagerPrev.removeClass('active')
      }
    }

    if (contentWidth <= Math.abs(currentSlide) + innerWidth) {
      currentSlide = -1 * contentWidth + innerWidth;
      if (this.pagerNext.hasClass('active')) {
          this.pagerNext.removeClass('active');
      }
    } else {
      if (!this.pagerNext.hasClass('active')) {
        this.pagerNext.addClass('active');
      }
    }

    if (currentSlide < 0) {
      if (!this.pagerPrev.hasClass('active')) {
          this.pagerPrev.addClass('active');
      }
    }

    if (this.windowWidth >= this.getBreakpoint()) {
      this.sliderInner.css({
        'transform':'translateX('+currentSlide+'px)',
        'width':contentWidth+'px'
      });
    } else {
      this.sliderInner.css({
        'transform':'translateX(0px)'
      });
      this.sliderContainer.scrollLeft(0);
    }

    this.sliderInner.data('current-slide', currentSlide);
  },
}

window.ProductSlider = ProductSlider;
